import React from 'react';
import { useState } from 'react';
import { FilterOutlined } from '@ant-design/icons';
import CustomButton from '../../../../v2-components/Antd/Button';
import CustomDrawer from '../../../../v2-components/Antd/Drawer';
import CustomCollapse from '../../../../v2-components/Antd/Collapse';
import CustomPanel from '../../../../v2-components/Antd/Panel';
import CustomInput from '../../../../v2-components/Antd/Input';
import { shouldAddItem } from '../../handle/should-add-item.handle'
import './style.scss'; 

export default function ProductFilter(props) {
	console.log('ProductFilter', props);
	// const [showDrawer, setShowDrawer] = useState(false);
	const [filterText] = useState('');

	return (
		<>
			<div className="own-landing-filter-container">
				<h5>Filtrar:</h5>
				<CustomButton
					className="own-landing-button"
					onClick={() => {
						props.setShowDrawer(true);
					}}
				>
					<FilterOutlined />
				</CustomButton>
			</div>

			<CustomDrawer
				className="own-landing-drawer"
				width={'325'}
				title="Filtrar Productos"
				placement="right"
				closable={true}
				onClose={() => props.setShowDrawer(false)}
				visible={props.showDrawer}
			>
				{/* <div className="own-landing-selected-filters">
					{selectedFilters?.map((filter, index) => (
						<div key={index} className="own-landing-filter-chip">
							<span>{filter.value}</span>
							<button 
								onClick={() => onChange(filter.value, filter.type, false)}
								className="own-landing-filter-chip-remove"
							>
								×
							</button>
						</div>
					))}
				</div> */}
				<div className="own-landing-collapse-container">
					<div className="own-landing-collapse-inner-container">
						<CustomCollapse
							expandIconPosition={'right'} 
							defaultActiveKey={['1', '2', '3', '4']}
						>
							<CustomPanel header={'Promociones'} key={1} className='own-landing-panel-item'>
								<div className="own-landing-filter-element">
									<div className={`own-checkboxes-container ${shouldAddItem(props?.filters?.categories, filterText) ? 'has-scroll' : ''}`}>
										{props?.filters?.promotions
											.filter((filter) => filter?.toLowerCase().includes(filterText.toLowerCase()))
											.map((filter, key) => (
												<div className="own-checkbox-inner-container" key={key}>
										
														<label htmlFor={filter}>{filter}</label>
														<CustomInput 
															type="checkbox"
															id={filter}
															name={filter}
															value={filter}
															onChange={(e) => props.onChange(filter, 'promotions', e.target.checked)}
															checked={props?.selectedFilters?.some((f) => f.option === filter)}
														/>
						
												</div>
											))}
									</div>
								</div>
							</CustomPanel>

							<CustomPanel header={'Categoría'} key={2} className='own-landing-panel-item'>
								<div className="own-landing-filter-element">
									<div className={`own-checkboxes-container ${shouldAddItem(props?.filters?.categories, filterText) ? 'has-scroll' : ''}`}>
										{props?.filters?.categories
											.filter((filter) => filter?.toLowerCase().includes(filterText.toLowerCase()))
											.map((filter, key) => (
												<div className="own-checkbox-inner-container" key={key}>
													<label htmlFor={filter}>{filter}</label>
														<div>
															<CustomInput
																type="checkbox"
																id={filter}
																name={filter}
																value={filter}
																onChange={(e) => props.onChange(filter, 'category', e.target.checked)}
																checked={props?.selectedFilters?.some((f) => f.option === filter)}
															/>
													
														</div>
						
												</div>
											))}
									</div>
								</div>
							</CustomPanel>

							<CustomPanel header={'Subcategoría'} key={3} className='own-landing-panel-item'>
								<div className="own-landing-filter-element">
									<div className={`own-checkboxes-container ${shouldAddItem(props?.filters?.sub_categories, filterText) ? 'has-scroll' : ''}`}>
										{props?.filters?.sub_categories
											.filter((filter) => filter?.toLowerCase().includes(filterText.toLowerCase()))
											.map((filter, key) => (
												<div className="own-checkbox-inner-container" key={key}>
											
														<label htmlFor={filter}>{filter}</label>
														<CustomInput 
															type="checkbox"
															id={filter}
															name={filter}
															value={filter}
															onChange={(e) => props.onChange(filter, 'sub_category', e.target.checked)}
															checked={props?.selectedFilters?.some((f) => f.option === filter)}
														/>
										
												</div>
											))}
									</div>
								</div>
							</CustomPanel>

							<CustomPanel header={'Laboratorio'} key={4} className='own-landing-panel-item'>
								<div className="own-landing-filter-element">
									<div className={`own-checkboxes-container ${shouldAddItem(props?.filters?.laboratories, filterText) ? 'has-scroll' : ''}`}>
										{props?.filters?.laboratories
											.filter((filter) => filter?.toLowerCase().includes(filterText.toLowerCase()))
											.map((filter, key) => (
												<div className="own-checkbox-inner-container" key={key}>
										
														<label htmlFor={filter}>{filter}</label>
														<CustomInput 
															type="checkbox"
															id={filter}
															name={filter}
															value={filter}
															onChange={(e) => props.onChange(filter, 'laboratory', e.target.checked)}
															checked={props?.selectedFilters?.some((f) => f.option === filter)}
														/>
										
												</div>
											))}
									</div>
								</div>
							</CustomPanel>
						</CustomCollapse>
					</div>
				</div>
			</CustomDrawer>
		</>
	);
}
